import Layout from '@@client/app/Layout'
import GeneralPage, {Header, Content, NarrowContent} from '@@client/app/GeneralPage'
import {getServerConfig} from '@@client/config'
import Markdown from '@@client/components/Markdown'

export function BasicContentPage({title, lead, content, failed}) {
    if(failed) return null

    return (
        <>
            <Layout title={title}>
                <GeneralPage>
                    <Header title={title}>
                        <Markdown>{lead || ''}</Markdown>
                    </Header>
                    <Content>
                        <NarrowContent>
                            <div className='content'><Markdown>{content || ''}</Markdown></div>
                        </NarrowContent>
                    </Content>
                </GeneralPage>
            </Layout>
            <style jsx>
                {`
                    @import '@css/variables.css';

                    .content {
                        :global(h2) {
                            color: $c--blue--darker;
                        }

                        :global(li) {
                            margin-bottom: 15px;

                            &:last-child {
                                margin-bottom: 0;
                            }
                        }
                    }
                `}
            </style>
        </>
    )
}

export const getServerSidePropsTemplate = (getContentFn) => async (ctx) => {
    const config = getServerConfig()

    const result = await getContentFn(config.content.apiUrl)

    return {
        props: result.success ? result.entity : {failed: true},
    }
}
